/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import OptionsIcon from '../../assets/options/Options';

import style from './DropdownMenu.module.scss';

export default class DropdownMenu extends React.Component {
  constructor() {
    super();

    this.state = {
      showMenu: false,
    };
  }

  showMenu = () => {
    this.setState({ showMenu: true }, () => {
      document.addEventListener('click', this.closeMenu);
    });
  }

  closeMenu = (event) => {
    if (
      this.dropdownMenu
      && !this.dropdownMenu.contains(event.target)) {
      this.setState({ showMenu: false }, () => {
        document.removeEventListener('click', this.closeMenu);
      });
    }
  }

  render() {
    const { showMenu } = this.state;
    const {
      children, clickElement, contentStyle, disabled,
    } = this.props;

    return (
      <div className={style.dropdownMenu} onClick={this.showMenu}>
        {clickElement ? <>{clickElement}</> : (
          <span onClick={this.showMenu} className={!showMenu ? style.optionsIcon : ''}>
            <OptionsIcon
              fill={showMenu ? '#0B7BBC' : '#BABCC0'}
            />
          </span>
        )}
        {showMenu
          ? (
            <div
              style={contentStyle}
              className={style.dropdownContent}
              ref={(element) => {
                this.dropdownMenu = element;
              }}
            >
              <div>
                <span data-tip href="#" data-for="global">
                  {children}
                </span>
                {disabled && (
                  <ReactTooltip className={style.tooltip} id="global" aria-haspopup="true">
                    {'You don\'t have access to this organisation'}
                  </ReactTooltip>
                )}
              </div>
            </div>
          )
          : null
        }
      </div>
    );
  }
}

DropdownMenu.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  clickElement: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  disabled: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  contentStyle: PropTypes.object,
};

DropdownMenu.defaultProps = {
  clickElement: undefined,
  contentStyle: {},
  disabled: false,
};
